<template>
    <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
        :class="className">
        <path d="M15 18L9 12L15 6" :stroke="strokeColor" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'ChevronLeftIcon',
    props: {
        strokeColor: {
            type: String,
            default: '#fff'
        },
        width: {
            type: [Number, String],
            default: 24
        },
        height: {
            type: [Number, String],
            default: 24
        },
        class: {
            type: String,
            default: ''
        }
    },
    setup(props) {
        const className = props.class;
        return {
            className
        };
    }
});
</script>